import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import css from './filter.css'

class PracticeSearchBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      localSearchString: '',
    }
  }

  updateLocalSearchString = (value) => {
    this.setState({ localSearchString: value })
    if (value.trim() === '') {
      this.props.updateSearchString('')
    }
  }

  onSearch = () => {
    this.props.updateSearchString(this.state.localSearchString)
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.onSearch()
    }
  }

  render() {
    return (
      <div className={css.searchContainer}>
        <div
          className={css.searchInput}
          contentEditable
          onInput={e => this.updateLocalSearchString(e.target.textContent)}
          onKeyDown={this.handleKeyDown}
          placeholder="Search practices by name, ID, or phone number"
          role="textbox"
          tabIndex={0}
        />
        <Button type="primary" size="large" onClick={this.onSearch}>
          Search &#x23CE;
        </Button>
      </div>
    )
  }
}

PracticeSearchBar.propTypes = {
  updateSearchString: PropTypes.func.isRequired,
}

export default PracticeSearchBar



// WEBPACK FOOTER //
// ./src/Dashboard/Filters/PracticeSearchBar.js